import { useMutation } from '@tanstack/react-query';
import { useSetupInfoAnaliseDeCoberturaStore } from '../SetupInfoPanelAnaliseDeCobertura.store';
import * as service from '../services';
import { NotificationMessage } from '../../../../../../components';
import { useGetCoverage } from './useGetCoverage';
import { SaveDataType } from '../@types';

export const useSaveCoverage = () => {
  const { draftCoverageSetupData, productUploadResponse, lojaUploadResponse, setSetupInfoAnaliseDeCoberturaState } = useSetupInfoAnaliseDeCoberturaStore();

  const { getCoverageRefetch } = useGetCoverage();

  const successAction = () => {
    setSetupInfoAnaliseDeCoberturaState('isProductNewFile', false);
    setSetupInfoAnaliseDeCoberturaState('isLojaNewFile', false);
    getCoverageRefetch();
    NotificationMessage('success', 5000, 'Alterações foram salvas com sucesso');
  };

  const saveCoverageMutation = useMutation({
    mutationFn: (payload: SaveDataType) => service.saveCoverage(payload),
    onSuccess: successAction,
  });

  const handleSaveCoverageMutation = () => {
    const { uf, cidade, tipoLoja, rede, canalDigital, canalFisico, lojaInteresse } = draftCoverageSetupData;

    const saveData = {
      uf,
      cidade,
      tipoLoja,
      rede,
      canalFisico,
      canalDigital,
      todasLojas: lojaInteresse === 'TODAS',
      idUploadGtin: productUploadResponse.uploadId || null,
      idUploadLoja: lojaUploadResponse.uploadId || null,
    } as SaveDataType;

    saveCoverageMutation.mutate(saveData);
  };
  return {
    handleSaveCoverageMutation,
  };
};
